import { actionZoneTypes, sizzleReelAZColor } from "constant";

  export const getActionZoneColor = function (azType, isSizzleReel) {
    if (isSizzleReel) { return sizzleReelAZColor; }

    switch (azType) {
      case actionZoneTypes.CompleteStop:
          return "#310000";
      case actionZoneTypes.StopAndReverse:
          return "#7D0000";
      case actionZoneTypes.Alert2mph:
      case actionZoneTypes.Limit3MPH:
      case actionZoneTypes.Limit4MPH:
          return "#B00000";
      case actionZoneTypes.Limit5MPH:
      case actionZoneTypes.Limit6MPH:
      case actionZoneTypes.Caution7mph:
          return "#FA8212";
      case actionZoneTypes.Limit8MPH:
      case actionZoneTypes.Limit9MPH:
      case actionZoneTypes.Caution10mph:
          return "#FAED12";
      case actionZoneTypes.NoSpeedRestriction:
          return "#5BFA12";
      default:
          return "#5BFA12";
    }
  };